export default __webpack_public_path__ + "static/media/two-number.eaced564.svg";